module.exports = __webpack_public_path__ + "img/check.6534d1a4.svg";